import type { RootState } from "@src/store/rootState";
import { getModificationsLockStatus } from "@src/store/slices/experienceBuilder/common/selectors/getModificationsLockStatus";
import { getOtherGroupsMods } from "@src/store/slices/experienceBuilder/common/selectors/getOtherGroupsMods";

export const shouldShowOtherMods = (state: RootState) => {
  const otherMods = getOtherGroupsMods(state);
  const lockStatus = getModificationsLockStatus(state);

  return otherMods.length > 0 && lockStatus !== "locked";
};
